import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=368af3ea&scoped=true&"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368af3ea",
  null
  
)

export default component.exports